import { NgModule } from '@angular/core'

import { LinkComponent } from './link.component'
import { RouterModule } from '@angular/router'
import { CmsComponentsBaseModule } from '../../cms-components-base.module'
import { SafeResourceUrlModule } from '../../../pipes/sanitize-resource-url/safe-resource-url.module'
import { UrlModule } from '@spartacus/core'
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap'

@NgModule({
  declarations: [
    LinkComponent
  ],
  imports: [
    CmsComponentsBaseModule,
    RouterModule,
    SafeResourceUrlModule,
    UrlModule,
    NgbNavModule
  ],
  exports: [
    LinkComponent
  ]
})
export class LinkModule {
}
